import handler from 'api/handler'

const prefix = '/public/exemptionRequest'

const methods = {
  submitExemption: args =>
    handler({ method: 'post', url: prefix + '/submit', args })
}

export default methods
